import React, { useState } from 'react';

const FIELD_LABELS = {
  name: 'Nom',
  title: 'Titre',
  subtitle: 'Sous-titre',
  description: 'Description',
  text: 'Texte',
  cta_label: 'Libellé du bouton',
  cta_secondary_label: 'Libellé du bouton secondaire',
  specialty: 'Spécialité',
  quote: 'Citation',
  bio: 'Biographie',
};

const labelize = (f) =>
  FIELD_LABELS[f] || f.replace(/_/g, ' ').replace(/^./, (c) => c.toUpperCase());

const LOCALE_LABELS = { fr: 'Français', ar: 'العربية', en: 'English' };

/**
 * Tabbed input for FR / AR / EN values. Use for any translatable field.
 *
 * Usage:
 *   <MultilingualField
 *     label="Titre"
 *     value={i18n}
 *     fields={['title', 'subtitle']}
 *     onChange={(next) => setI18n(next)}
 *     multiline={['subtitle']}
 *   />
 */
export default function MultilingualField({ label, value, fields = ['name'], onChange, multiline = [] }) {
  const [tab, setTab] = useState('fr');
  const v = value || {};
  const setVal = (locale, field, val) => {
    onChange({ ...v, [locale]: { ...(v[locale] || {}), [field]: val } });
  };

  return (
    <div className="multi-field">
      {label && <div className="multi-field__title">{label}</div>}
      <div className="multi-field__locales" role="tablist">
        {['fr', 'ar', 'en'].map((l) => (
          <button
            type="button"
            key={l}
            role="tab"
            aria-selected={tab === l}
            onClick={() => setTab(l)}
            className={`multi-field__locale${tab === l ? ' is-active' : ''}`}
          >
            <span className="multi-field__locale-code">{l.toUpperCase()}</span>
            <span className="multi-field__locale-name">{LOCALE_LABELS[l]}</span>
          </button>
        ))}
      </div>
      <div className="multi-field__body">
        {fields.map((f) => (
          <div key={f} className="multi-field__row">
            <label className="admin-label">{labelize(f)}</label>
            {multiline.includes(f) ? (
              <textarea
                className="admin-textarea"
                rows={3}
                dir={tab === 'ar' ? 'rtl' : 'ltr'}
                value={v[tab]?.[f] ?? ''}
                onChange={(e) => setVal(tab, f, e.target.value)}
              />
            ) : (
              <input
                className="admin-input"
                type="text"
                dir={tab === 'ar' ? 'rtl' : 'ltr'}
                value={v[tab]?.[f] ?? ''}
                onChange={(e) => setVal(tab, f, e.target.value)}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
